import Typography from 'components/shared/generic/typography/presentational/Typography';
import LoadingIcon from '_content/images/icons/more/loading.png';
import SuccessIcon from '_content/images/icons/more/success.png';
import { getTheme } from 'selectors/darkMode';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import useTranslate from 'lib/languages/useTranslate';

interface IGenerateText {
    headerText: string;
    text: string;
    icon: string;
}

interface CopCheckModalProps {
    isPayeeCreated: boolean;
}

const CopCheckModal = ({ isPayeeCreated }: CopCheckModalProps) => {
    const translate = useTranslate('addPayee');
    const isDarkModeEnabled = useSelector(getTheme);

    const generatePayeeModalText = useMemo((): IGenerateText => {
        const accountTypeHeaderText = translate('checking');

        const accountMatchSubText = translate('match');

        const finalHeaderText = !isPayeeCreated
            ? accountTypeHeaderText
            : translate('success');
        const finalSubText = !isPayeeCreated
            ? translate('pleaseWait')
            : accountMatchSubText;
        const statusIcon = !isPayeeCreated ? LoadingIcon : SuccessIcon;

        return {
            headerText: finalHeaderText,
            text: finalSubText,
            icon: statusIcon,
        };
    }, [isPayeeCreated, translate]);

    const { headerText, text, icon: Icon } = generatePayeeModalText;

    return (
        <div className="login-container checking-container d-flex-col-center">
            <div className="checking-box">
                <div
                    className={`checking-content ${
                        isDarkModeEnabled ? 'dark-mode' : ''
                    }`}
                >
                    <Typography tag="h1">{headerText}</Typography>
                    <img
                        alt="loading"
                        src={Icon}
                        className={`mb-2 ${isPayeeCreated && 'imageSuccess'}`}
                    />
                    <Typography tag="p">{text}</Typography>
                </div>
            </div>
        </div>
    );
};

export default CopCheckModal;
